<template>
	<div class="select-data-container" :style="'width:'+ width">
		<slot name="errorMsg" v-if="status === 'nodata' || status === 'error' && !errorMsg"></slot>
		<div class="line-height-34 select-data-value text-secondary"
			 v-if="(status === 'nodata' || status === 'error') && errorMsg !== ''">{{errorMsg}}
		</div>
		<div class="line-height-34 select-data-value" v-if="status === 'loading'">
			<img src="../../assets/image/load-sm.gif">
		</div>
		<slot v-if="status === 'havedata'"></slot>
	</div>
</template>

<script>
    import SelectData from "./select-data";

    export default SelectData;
</script>

<style lang="scss">

</style>
